import React from 'react'
import slider3 from '../../../../assets/img/slider3.webp'
import { Link } from 'react-router-dom'

function SliderAbout3Sec1() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link></li> 
               <li>Tailoring your needs with the sharpest tools</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>Tailoring your needs with  <span>the sharpest tools</span></h2>
              <p>With Game-Changing Tools and <b>cutting edge technology tailored</b> to your exact needs, our team puts careful attention towards analyzing your development needs and works closely to define an application software that complements your business. Our integrated product engineering capabilities coupling software & equipment enable customized technology to perfectly fit your functional needs.</p>
            </div> 
           <div className='hmslder-img'>
              <img src={slider3} alt='Tailoring your needs with the sharpest tools' width={1200} height={800} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default SliderAbout3Sec1
